import { render, staticRenderFns } from "./confirmation-status.vue?vue&type=template&id=70570982"
import script from "./confirmation-status.vue?vue&type=script&lang=js"
export * from "./confirmation-status.vue?vue&type=script&lang=js"
import style0 from "./confirmation-status.vue?vue&type=style&index=0&id=70570982&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports